<template>
  <div class="c-divider"></div>
</template>

<style lang="scss">
.c-divider {
  margin: var(--core-spacer, 20px) 0;
  border-bottom: var(--core-divider-width) solid var(--core-divider-color);
}
</style>